import type { ReactNode } from 'react';

export const symbol_heat_pump: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M310-310q-70-70-70-170t70-170q70-70 170-70t170 70q70 70 70 170t-70 170q-70 70-170 70t-170-70Zm150 9v-131l-92 92q20 17 43 27t49 12Zm40 0q26-3 49-13.5t43-25.5l-92-92v131Zm120-67q16-20 27-43t13-49H528l92 92Zm-92-132h131q-2-26-12-49t-27-43l-92 92Zm-28-28 92-92q-20-16-43-26.5T500-659v131Zm1.5 69.32q8.5-8.67 8.5-21.5 0-12.82-8.68-21.32-8.67-8.5-21.5-8.5-12.82 0-21.32 8.68-8.5 8.67-8.5 21.5 0 12.82 8.68 21.32 8.67 8.5 21.5 8.5 12.82 0 21.32-8.68ZM460-528v-131q-26 1-49 11.5T368-620l92 92Zm-159 28h131l-92-92q-16 20-26.5 43T301-500Zm39 132 92-92H301q3 26 13 49t26 43ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
